import VueApexCharts from 'vue-apexcharts'
import api from '../../services/service_report'
import Swal from 'sweetalert2'
import moment from 'moment'

export default {
  data () {
    return {
      dateNow: new Date(),
      income: [],
      incomeOptions: {},
      expend: [],
      expendOptions: {},
      outstand: [0, 0],
      outstandOptions: {},
      diff: [],
      diffOptions: {},
      header: {
        headers: {
          'access-token': this.$store.state.token
        }
      }
    }
  },
  components: {
    apexchart: VueApexCharts
  },
  methods: {
    getIncome () {
      this.$store.state.isLoading = true
      api.getReceive(
        {
          'date': this.dateNow,
          'active_page': 1,
          'per_page': 10000000
        },
        this.header,
        result => {
          if (result.response === true) {
            let day = []
            let money = []
            var date = ''
            var total = 0
            var i = 1
            result.data.pagination.forEach(val => {
              if (val['receive_date'] === date) {
                total += parseFloat(val['payment_amount'])
              } else {
                if (total > 0) {
                  money.push(total)
                  day.push(moment(date).format('DD'))
                }
                date = val['receive_date']
                total = parseFloat(val['payment_amount'])
              }
              if (result.data.pagination.length === i) {
                money.push(total)
                day.push(moment(date).format('DD'))
              }
              i++
            })
            this.income = [{
              name: 'รายรับ',
              data: money
            }]
            this.incomeOptions = {
              chart: {
                zoom: {
                  enabled: false
                }
              },
              colors: ['#1dd600'],
              dataLabels: {
                enabled: false
              },
              stroke: {
                curve: 'straight'
              },
              grid: {
                row: {
                  colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
                  opacity: 0.5
                }
              },
              xaxis: {
                categories: day
              }
            }
          } else {
            Swal.fire('ดึงข้อมูลหมวดหมู่', result.message, 'warning')
          }
        },
        error => {
          alert(JSON.stringify(error))
          this.$store.state.isLoading = false
        }
      )
    },
    getExpend () {
      this.$store.state.isLoading = true
      api.getExpend(
        {
          'date': this.dateNow,
          'active_page': 1,
          'per_page': 10000000
        },
        this.header,
        result => {
          if (result.response === true) {
            let day = []
            let money = []
            var date = ''
            var total = 0
            var i = 1
            result.data.pagination.forEach(val => {
              if (val['expense_date'] === date) {
                total += parseFloat(val['expense_amount'])
              } else {
                if (total > 0) {
                  money.push(total)
                  day.push(moment(date).format('DD'))
                }
                date = val['expense_date']
                total = parseFloat(val['expense_amount'])
              }
              if (result.data.pagination.length === i) {
                money.push(total)
                day.push(moment(date).format('DD'))
              }
              i++
            })
            this.expend = [{
              name: 'รายจ่าย',
              data: money
            }]
            this.expendOptions = {
              chart: {
                zoom: {
                  enabled: false
                }
              },
              colors: ['#ff0000'],
              dataLabels: {
                enabled: false
              },
              stroke: {
                curve: 'straight'
              },
              grid: {
                row: {
                  colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
                  opacity: 0.5
                }
              },
              xaxis: {
                categories: day
              }
            }
          } else {
            Swal.fire('ดึงข้อมูลหมวดหมู่', result.message, 'warning')
          }
        },
        error => {
          alert(JSON.stringify(error))
          this.$store.state.isLoading = false
        }
      )
    },
    getOutstand () {
      this.$store.state.isLoading = true
      api.getInvoice(
        {
          'date': this.dateNow,
          'active_page': 1,
          'per_page': 10000000
        },
        this.header,
        result => {
          if (result.response === true) {
            this.$store.state.isLoading = false
            if (result.data.pagination.length > 0) {
              let invoice = parseFloat(result.data.pagination[0]['invoice_amount'])
              let overdue = parseFloat(result.data.pagination[0]['overdue_amount'])
              let payment = parseFloat(result.data.pagination[0]['payment_amount'])
              this.outstand = [invoice, overdue, payment]
              this.outstandOptions = {
                labels: ['รายรับ', 'ค้างชำระ', 'ชำระแล้ว'],
                responsive: [{
                  breakpoint: 400,
                  options: {
                    chart: {
                      width: 200
                    },
                    legend: {
                      position: 'bottom'
                    }
                  }
                }]
              }
            }
          } else {
            Swal.fire('ดึงข้อมูลหมวดหมู่', result.message, 'warning')
            this.$store.state.isLoading = false
          }
        },
        error => {
          alert(JSON.stringify(error))
          this.$store.state.isLoading = false
        }
      )
    },
    getDiffIncome () {
      this.$store.state.isLoading = true
      api.getDiff(
        {
          'date': this.dateNow,
          'active_page': 1,
          'per_page': 31
        },
        this.header,
        result => {
          if (result.response === true) {
            this.$store.state.isLoading = false
            let day = []
            let receivemoney = []
            let expensemoney = []
            result.data.pagination.forEach(val => {
              day.push(moment(val['db_date']).format('DD'))
              receivemoney.push(val['receive_amount'])
              expensemoney.push(val['expense_amount'])
            })
            this.diff = [{
              name: 'รายรับ',
              data: receivemoney
            }, {
              name: 'รายจ่าย',
              data: expensemoney
            }]
            this.diffOptions = {
              plotOptions: {
                bar: {
                  horizontal: false,
                  columnWidth: '80%'
                }
              },
              colors: ['#00ff22', '#ff0000'],
              dataLabels: {
                enabled: false
              },
              stroke: {
                show: true,
                width: 2,
                colors: ['transparent']
              },
              xaxis: {
                categories: day
              },
              yaxis: {
                title: {
                  text: 'ยอดเงิน'
                }
              },
              fill: {
                opacity: 1

              },
              tooltip: {
                y: {
                  formatter: function (val) {
                    return this.numberFormat(val) + ' บาท'
                  }.bind(this)
                }
              }
            }
          } else {
            Swal.fire('ดึงข้อมูลหมวดหมู่', result.message, 'warning')
            this.$store.state.isLoading = false
          }
        },
        error => {
          alert(JSON.stringify(error))
          this.$store.state.isLoading = false
        }
      )
    }
  },
  mounted () {
    if (sessionStorage.user) {
      this.$store.state.token = sessionStorage.token
      this.$store.state.user = JSON.parse(sessionStorage.user)
      if (sessionStorage.config) {
        this.$store.state.config = JSON.parse(sessionStorage.config)
      }
      var d = new Date()
      d.setDate(11)
      if (this.dateNow < d) {
        this.dateNow = new Date(this.dateNow.setMonth(this.dateNow.getMonth() - 1))
      }
      this.getOutstand()
      this.getIncome()
      this.getExpend()
      this.getDiffIncome()
    } else {
      this.$router.push('/login')
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/dashboard.js